import axios from "axios";
import {
  ADD_INHOUDINGEN,
  ADD_TOELAGEN,
  CALCULATE_TAX_TABLE,
  SAVE_COMP_DETAILS,
  SAVE_EMPLOYEE_DATA,
  SAVE_TAX_CALC_INPUT,
  STORE_RESPONSE,
} from "./actionTypes";

export const calucate = (
  taxCalcData,
  toelagen,
  inhoudingen,
  bedrag,
  selectAfterValue,
  history
) => (dispatch) => {
  const fullToelagenArray = toelagen;
  const fullInhoudingenArray = inhoudingen;

  for (var i = toelagen.length; i < 7; i++) {
    fullToelagenArray.push({
      label: "blanco",
      bedrag: 0,
      belastbaar: true,
      isBedrag: true,
    });
  }

  for (var y = inhoudingen.length; y < 7; y++) {
    fullInhoudingenArray.push({
      label: "blanco",
      bedrag: 0,
      belastbaar: true,
      isBedrag: true,
    });
  }

  // while(inhoudingen.length < 7){
  //   inhoudingen.push({ label: "blanco", bedrag: 0, belastbaar: true, isBedrag: true },)
  // }

  const {
    forfait,
    taxFreeSum,
    heffingskorting,
    sc1min,
    sc1max,
    sc1per,
    sc2min,
    sc2max,
    sc2per,
    sc3min,
    sc3max,
    sc3per,
    sc4min,
    sc4max,
    sc4per,
    sc5min,
    sc5max,
    sc5per,
  } = taxCalcData;

  let schalen = [
    [sc1min, sc1max, sc1per],
    [sc2min, sc2max, sc2per],
    [sc3min, sc3max, sc3per],
    [sc4min, sc4max, sc4per],
    [sc5min, null, sc5per],
  ];

  let salaris = {
    brutoOfNettoBedrag: bedrag,
    isBrutoBedrag: selectAfterValue === "bruto" ? true : false,
  };

  let taxCalculationInput = {
    forfait,
    taxFreeSum,
    heffingskorting,
  };

  // const data = {
  //   nettoInkomen: bedrag,
  //   brutoSalaris: bedrag,
  //   toelagen,
  //   inhoudingen,
  //   taxCalculationInput: taxCalculationInput,
  //   schalen: schalen,
  //   isLoonslip: salaris.isBrutoBedrag == 1,
  // };

  const data = {
    nettoInkomen: bedrag,
    brutoSalaris: bedrag,

    toelagen: fullToelagenArray,
    inhoudingen: fullInhoudingenArray,

    // toelagen: [
    //   { label: "vervoer", bedrag: 200, belastbaar: true, isBedrag: true },
    //   { label: "kleding", bedrag: 358, belastbaar: false, isBedrag: true },
    //   { label: "blanco", bedrag: 0, belastbaar: false, isBedrag: true },
    //   { label: "blanco", bedrag: 0, belastbaar: false, isBedrag: true },
    //   { label: "blanco", bedrag: 0, belastbaar: false, isBedrag: true },
    //   { label: "blanco", bedrag: 0, belastbaar: false, isBedrag: true },
    //   { label: "blanco", bedrag: 0, belastbaar: false, isBedrag: true },
    // ],
    // inhoudingen: [
    //   { label: "bond", bedrag: 100, belastbaar: true, isBedrag: true },
    //   { label: "lidmaatschap", bedrag: 35, belastbaar: true, isBedrag: true },
    //   { label: "aov", bedrag: 35, belastbaar: false, isBedrag: true },
    //   { label: "blanco", bedrag: 0, belastbaar: false, isBedrag: false },
    //   { label: "blanco", bedrag: 0, belastbaar: false, isBedrag: true },
    //   { label: "blanco", bedrag: 0, belastbaar: false, isBedrag: false },
    //   { label: "blanco", bedrag: 0, belastbaar: false, isBedrag: false },
    // ],
    taxCalculationInput: taxCalculationInput,
    schalen: schalen,
    isLoonslip: salaris.isBrutoBedrag == 1,
  };

  // for( var i = toelagen.length; i < 7; i++){
  //   data.toelagen.push({ label: "blanco", bedrag: 0, belastbaar: true, isBedrag: true },)
  // }

  // for( var y = inhoudingen.length; y < 7; y++){
  //   data.inhoudingen.push({ label: "blanco", bedrag: 0, belastbaar: true, isBedrag: true },)
  // }

  // while(inhoudingen.length < 7){
  //   data.inhoudingen.push({ label: "blanco", bedrag: 0, belastbaar: true, isBedrag: true },)
  // }
  let config = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "POST",
      "Content-Type": "application/json;charset=UTF-8",
    },
  };

  axios
    .post(
      "https://5wi0fpuj19.execute-api.us-east-1.amazonaws.com/api/generateLoonslip ",
      JSON.stringify(data),
      config
    )
    .then((res) => {
      dispatch({
        type: CALCULATE_TAX_TABLE,
        payload: res.data,
      });
      history.push("/loonslip-calculatie");
    })
    .catch((err) => {
      console.log(err.response);
    });
};

export const uploadEmployeeData = (
  companyInformation,
  taxCalculationInput,
  schalen,
  employeeData,
  history
) => (dispatch) => {
  const form = new FormData();
  form.append("csvData", JSON.stringify(employeeData));
  form.append("taxCalculationInput", JSON.stringify(taxCalculationInput));
  form.append("schalen", JSON.stringify(schalen));
  form.append("company", JSON.stringify(companyInformation));

  let config = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "POST",
    },
  };
  // axios.post('https://calculate.tax.sr/api/generateLoonstroken', form, config).then(res => {
  axios
    .post("https://5wi0fpuj19.execute-api.us-east-1.amazonaws.com/api/generateLoonstroken", form, config)
    .then((res) => {
      dispatch({
        type: STORE_RESPONSE,
        payload: res.data,
      });
      history.push("/employee-table");
    })
    .catch((err) => {
      console.log(err.response);
      // dispatch(showMiscModal('error', err.response))
    });
};

export const saveTaxCalcInput = (data) => ({
  type: SAVE_TAX_CALC_INPUT,
  payload: data,
});

export const saveCompDetails = (data) => ({
  type: SAVE_COMP_DETAILS,
  payload: data,
});

export const saveEmployeeData = (data) => ({
  type: SAVE_EMPLOYEE_DATA,
  payload: data,
});

export const addToelagen = (data) => ({
  type: ADD_TOELAGEN,
  payload: data,
});

export const addInhoudingen = (data) => ({
  type: ADD_INHOUDINGEN,
  payload: data,
});
